import React from "react";
import CustomTooltip from "../controls/CustomTooltip/CustomTooltip";
import Const from ".././../const.json";
import { TooltipPlacementEnum, TooltipTriggerEnum } from "enums/enums";
import infoIcon from "../../assets/icons/info.svg";
import "./Card.scss";

interface CardProps {
  header?: string;
  subHeader?: string;
  components: React.ReactNode[];
  isTooltip?: boolean;
  tooltipContent?: string;
}

const Card: React.FC<CardProps> = ({
  header,
  components,
  subHeader = "",
  isTooltip = false,
  tooltipContent = "",
}) => {
  return (
    <div className="cardBI h-100">
      <h3 className="card-title-width mb-1">
        {header}
        {isTooltip && (
          <CustomTooltip
            content={tooltipContent}
          />
        )}
      </h3>
      {subHeader && (
        <h4 className="new-line card-title-width mb-3" >
          {subHeader}
        </h4>
      )}
      {components.map((component, index) => (
        <div key={index}>{component}</div>
      ))}
    </div>
  );
};

export default Card;
